// Prefixes
export const STATE_PREFIX = "wec-state-";

// Helper
export const TOUCH = "wec-h-touch";
export const NO_TOUCH = "wec-h-no-touch";
export const INVERTED = "wec-h-inverted";

// States
export const ACTIVE = "wec-state-active";
export const LOADING = "wec-state-loading";
export const OPEN = "wec-state-open";
export const INVALID = "wec-state-invalid";
export const LOADED = "wec-state-loaded";
export const ERROR = "wec-state-error";
export const HIDDEN = "wec-state-hidden";
export const VISIBLE = "wec-state-visible";
export const INVISIBLE = "wec-state-invisible";
export const INACTIVE = "wec-state-inactive";
export const UNSTARTED = "wec-state-unstarted";
export const SCROLL_LOCK = "wec-state-scroll-lock";
export const ANIMATE = "wec-state-animate";
export const ANIMATING = "wec-state-animating";
export const IN_VIEWPORT = "wec-state-invp";
export const DRAGGING = "wec-state-dragging";
export const SCROLLING = "wec-state-scrolling";
export const MINIMAL = "wec-state-minimal";
export const UP = "wec-state-up";
export const DOWN = "wec-state-down";
export const DISABLED = "wec-state-disabled";
export const SELECTED = "wec-state-selected";
export const CAN_SUBMIT = "wec-state-can-submit";
export const HAS_OVERFLOW = "wec-state-has-overflow";
export const HASCOOKIE = "wec-state-has-cookie";
export const INITIALIZED = "wec-state-initialized";
export const OVERLAY_OPEN = "wec-state-overlay-open";
export const SUCCESS = "wec-state-success";
export const PLAYING = "wec-state-playing";
export const FINISHED = "wec-state-finished";
export const STICKY = "wec-state-sticky";
export const KEYBOARD_FOCUS = "wec-h-keyboard-focus";
export const FOCUS = "wec-state-focus";
export const CAN_SCROLL_RIGHT = "wec-state-can-scroll-right";
export const CAN_SCROLL_LEFT = "wec-state-can-scroll-left";
export const HIDDEN_HEADER = "wec-state-hidden-header";
export const CUSTOMER_MODE_B2B = "wec-customer-mode-b2b";
export const CUSTOMER_MODE_B2C = "wec-customer-mode-b2c";
